/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IHtmlBlockViewProps } from './html-block';

const HtmlBlockView: React.FC<IHtmlBlockViewProps> = props => (
    <div className={props.className} id={props.id} {...props.renderModuleAttributes(props)}>
        {props.content}
    </div>
);

export default HtmlBlockView;
